import {format} from 'date-fns';
import {enGB, enUS, es, fr, uk} from 'date-fns/locale';

const locales = {fr, uk, es, enGB, enUS, en: enGB}

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
function formatWithLocale(date, formatStr = 'PP') {
  return format(new Date(date), formatStr, {
    locale: locales[window.__localeId__] // or global.__localeId__
  })
}

function createLegalAgeDate(days, months, years) {
  var date = new Date(); 
  date.setDate(date.getDate() + days);
  date.setMonth(date.getMonth() + months);
  date.setFullYear(date.getFullYear() + years);
  return date;
}

function formatForRequest(date, formatStr = 'yyyy-MM-dd') {
  return format(date, formatStr);
}

export {locales, formatWithLocale, formatForRequest, createLegalAgeDate};
